import { defineComponent as _defineComponent } from 'vue'
import { useImage } from '@/shared/composables/image'
import BKImage from '@/components/AppShared/BKImage.vue'
import { EventDB } from '@/enitites/event'
import { EventMapDB } from '@/enitites/map'
import EventCompactCard from '@/shared/ui/cards/EventCompactCard.vue'

interface IProps {
  event: EventDB | EventMapDB
}


export default /*#__PURE__*/_defineComponent({
  __name: 'EventPreviewCompactCard',
  props: {
    event: null
  },
  setup(__props: any) {

const props = __props as {
  event: EventDB | EventMapDB
};

const { getImageById } = useImage()


const srcImg = getImageById(props.event.image, 190, 190, 'event')

function formattedDate(date: Date) {
  return new Date(date).toLocaleDateString('en-US')
}

return { __sfc: true,getImageById, props, srcImg, formattedDate, BKImage, EventCompactCard }
}

})